import { Link } from "react-router-dom";
import MangaCard from "@/components/feature/MangaCard";
import { mangaList } from "@/mocks/manga";

const hot = [...mangaList].sort((a, b) => b.rating - a.rating).slice(0, 4);
const updates = [...mangaList].slice(0, 6);

export default function Featured() {
  return (
    <section className="mt-12 bg-background-100/60 py-12 md:mt-16 md:py-16">
      <div className="container-page">
        <div className="flex items-end justify-between">
          <div>
            <span className="chip bg-accent-100 text-accent-800">
              <i className="ri-fire-fill mr-1" aria-hidden="true"></i>
              本周热榜
            </span>
            <h2 className="mt-3 text-xl font-bold text-foreground-950 md:text-2xl">读者都在追的高分萌系漫画</h2>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {hot.map((m) => (
            <MangaCard key={m.slug} manga={m} />
          ))}
        </div>

        <div className="mt-10 flex items-end justify-between">
          <div>
            <span className="chip bg-secondary-100 text-secondary-900">
              <i className="ri-refresh-line mr-1" aria-hidden="true"></i>
              最近更新
            </span>
            <h2 className="mt-3 text-xl font-bold text-foreground-950 md:text-2xl">今日连载不停歇</h2>
          </div>
        </div>

        <div className="mt-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          {updates.map((m, i) => (
            <Link
              key={m.slug}
              to={`/manga/${m.slug}`}
              className="flex items-center gap-4 border-b border-background-100 px-4 py-3.5 transition-colors last:border-0 hover:bg-secondary-50"
            >
              <span className="w-6 text-center font-heading text-lg font-bold text-foreground-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <img
                src={m.cover}
                alt={m.title}
                className="h-12 w-9 shrink-0 rounded-md object-cover"
              />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-bold text-foreground-950">{m.title}</p>
                <p className="truncate text-xs text-foreground-600">
                  {m.episode} · <span className="text-primary-700">{m.categoryName}</span>
                </p>
              </div>
              <div className="hidden items-center gap-1 text-xs text-foreground-500 sm:flex">
                <i className="ri-time-line" aria-hidden="true"></i>
                {m.updateTime}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}